<template>
  <div v-loading="showFlag">
    <!--  再入荷申請確認画面 -->
    <t-card>
      <div>
        <t-row class="marginBottom">
          <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
            >&nbsp;</t-col
          >
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))"
          >
            <!-- テーブル -->
            <div>
              <t-table
                ref="jpReceAgainForm"
                :data="jpReceAgainForm"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                :cell-class-name="tableCellClassName"
                border
                fit
              >
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                  <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->
                  <template slot-scope="scope">
                    <t-date-picker
                      v-if="dueDateInputProc(scope.row, column)"
                      v-model="scope.row[column.prop]"
                      class="dialogDate"
                      :clearable="false"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :show-icon="false"
                    >
                    </t-date-picker>
                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                  <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                </t-table-column>
              </t-table>
            </div>
          </t-col>
          <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
            >&nbsp;</t-col
          >
        </t-row>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row>
            <div>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
              <t-col
                :span="
                  parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))
                "
                class="right"
              >
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="confirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  getJpReceInitList,
  getOrderDetailForm,
  saveReceAgainOrderInfo,
} from "@/services/jpReceive";
import {
  formatCurDateToString,
  formatDateToString,
  getDialogContentHeight,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, NUM_ZERO, STR_ONE, STR_ZERO } from "@/utils/const";
import { setColumnWidth } from "@/utils/table";
import { Message } from "@tellus/component";
export default {
  data() {
    return {
      //日本入荷一覧選択情報
      jpReceAgainForm: [
        {
          jrdOrderNo: "", // 注文No
          odOrderDetailNo: "", //注文明細No.
          aodProdName: "", // 品名
          aodProdDrawNo: "", // 図番,
          jrdReceNgQty: "", //再入荷申請数
          jrdProdExKbn: "", // 製品異常区分
          aodProdUnit: "", //単位
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          odDueDate: "", //仕入先納期
          odDueDateHistory: "", //仕入先納期履歴
          odProdGroupNo: "", //注文製品明細No.
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        },
      ],

      saveOrderDetailForm: [],

      //注文明細データ
      OrderDetailForm: [],

      //テーブルの列
      columns: [
        // 注文No
        {
          prop: "jrdOrderNoShow",
          label: t("resource.JP_RECEIVE.ORDER_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.JP_RECEIVE.PRODUCT_NAME"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.JP_RECEIVE.PRODUCT_DRAW_NO"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 再入荷申請数
        {
          prop: "jrdReceNgQty",
          label: t("resource.JP_RECEIVE.AGQIN_RECE_NUM"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.JP_RECEIVE.PRODUCT_UNIT"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },

        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // 仕入先納期
        {
          prop: "odDueDate",
          label: t("resource.ORDER.OD_DUE_DATE"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_center",
        },
        // 仕入先納期履歴
        {
          prop: "odDueDateHistory",
          label: t("resource.ORDER.OD_DUE_DATE_HISTORY"),
          width: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],

      // 異常区分
      prodExKbnList: [],

      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      showFlag: false,
    };
  },

  props: {
    receAgainData: {
      Type: Object,
      default: null,
    },

    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 納期、注番の変更(見積単位⇒製品単位に変更)
    receAgainDataBasic: {
      Type: Object,
      default: null,
    },
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
  },
  mounted() {
    this.init(this.receAgainData);

    //列幅に自動調整
    setColumnWidth(this.columns, this.jpReceAgainForm);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        20
      );
    },

    // 初期化
    init(data) {
      this.showFlag = true;
      this.jpReceAgainForm = data;
      getJpReceInitList()
        .then((res) => {
          //異常区分
          this.prodExKbnList = res.prodExKbnList;
          this.getOrderDetailForm();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
          this.showFlag = false;
        });
      //列幅に自動調整
      setColumnWidth(this.jpReceAgainForm);
      ///注文明細データの取得
    },

    //注文明細データの取得
    getOrderDetailForm() {
      this.dataProcess();

      // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      //getOrderDetailForm({ receAgainOrderInfoList: this.jpReceAgainForm })
      getOrderDetailForm({
        receAgainOrderInfoList: this.receAgainData,
        jpReceBasicInfo: this.receAgainDataBasic,
      })
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        .then((res) => {
          this.OrderDetailForm = res.receAgainOrderInfoList;
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          for (var i = 0; i < this.jpReceAgainForm.length; i++) {
            //仕入先納期
            this.jpReceAgainForm[i].odDueDate = new Date(
              res.receAgainOrderInfoList[i].odDueDate
            );
            //仕入先納期履歴
            this.jpReceAgainForm[i].odDueDateHistory =
              res.receAgainOrderInfoList[i].odDueDateHistory;
          }
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        })
        .catch((err) => {
          Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //データ処理
    dataProcess() {
      this.jpReceAgainForm.map((item) => {
        if (item.jrdProdExKbn === "-") {
          item.odProdExKbn = this.prodExKbnList.find(
            (it) => it.statusColor === item.jrdProdExKbn
          )?.value;
        }

        item.odOrderNo = item.jrdOrderNo;
        item.odOrderDetailNo = item.jrdDetailNo;
        return item;
      });
    },

    //确定ボタン
    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      if (this.jpReceAgainForm) {
        if (!this.showFlag) {
          this.showFlag = true;
        }
        this.saveOrderDataProcess();

        saveReceAgainOrderInfo({
          receAgainOrderInfoList: this.saveOrderDetailForm,
        })
          .then((res) => {
            Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
            }
          })
          .finally(() => {
            this.showFlag = false;
          });
      } else {
        Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
        this.showFlag = false;
      }
      this.$emit("ok");
    },

    //保存されたデータ処理
    saveOrderDataProcess() {
      for (let index = 0; index < this.jpReceAgainForm.length; index++) {
        const element = this.jpReceAgainForm[index];

        this.saveOrderDetailForm = this.OrderDetailForm;

        for (let j = 0; j < this.OrderDetailForm.length; j++) {
          const detailElement = this.OrderDetailForm[j];

          if (
            element.odOrderNo == detailElement.odOrderNo &&
            detailElement.odOrderDetailNo == element.odOrderDetailNo
          ) {
            // 注文数量
            detailElement.odProdQuantity = NUM_ZERO;
            detailElement.odPayStatus = STR_ONE; //支払状態：未支払
            detailElement.odProdExKbn = STR_ONE; //製品異常区分：入荷異常
            detailElement.odProdExQty = element.jrdReceNgQty; //異常件数
            detailElement.odProdCloseQty = NUM_ZERO; //クローズ件数
            detailElement.odProdSuppQty = NUM_ZERO; //補足件数
            detailElement.odProdSuppPayQty = NUM_ZERO; //補足支払数
            detailElement.odCloseState = STR_ZERO; //クローズ状態

            // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
            // 納期、注番の変更(見積単位⇒製品単位に変更)
            //仕入先納期
            detailElement.odDueDate = formatCurDateToString(element.odDueDate);
            // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

            var currentDate = new Date();
            // 異常製品の提出日
            detailElement.odExCreateDate = formatDateToString(currentDate);
            // 異常製品納品No.
            detailElement.odExReceSendNo = element.jrdReceNo;
            // 異常製品入荷/納品明細No.
            detailElement.odExReceSendDetailNo = element.jrdReceDetailNo;
            // 異常製品支払方式  1：不要
            detailElement.odExPayMethod = STR_ONE;
            // 備考
            detailElement.odRemarks = element.jrdRemarks;
            // 注文書出力 0：チェックしない
            detailElement.odOrderNoteOut = STR_ZERO;
            // 支払数
            detailElement.odPayQuantity = NUM_ZERO;
            detailElement.odUpdateUser = getUserInfo().UserId;
          }
        }
      }
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // 製品のフラグ  true:新規　false:編集
      var exProdFlag = this.jpReceAgainForm.every((obj1, index) => {
        const obj2 = this.OrderDetailForm[index];
        return obj1.odOrderDetailNo === obj2.odOrderDetailNo;
      });
      //編集の場合、データを変更する
      if (!exProdFlag) {
        for (var x = 0; x < this.OrderDetailForm.length; x++) {
          const detailElement = this.OrderDetailForm[x];
          const element = this.jpReceAgainForm[x];
          detailElement.odProdQuantity = NUM_ZERO;
          detailElement.odPayStatus = STR_ONE; //支払状態：未支払
          detailElement.odProdExKbn = STR_ONE; //製品異常区分：入荷異常
          detailElement.odProdExQty = element.jrdReceNgQty; //異常件数
          detailElement.odProdCloseQty = NUM_ZERO; //クローズ件数
          detailElement.odProdSuppQty = NUM_ZERO; //補足件数
          detailElement.odProdSuppPayQty = NUM_ZERO; //補足支払数
          detailElement.odCloseState = STR_ZERO; //クローズ状態
          //仕入先納期
          detailElement.odDueDate = formatCurDateToString(element.odDueDate);
          var currentDate = new Date();
          // 異常製品の提出日
          detailElement.odExCreateDate = formatDateToString(currentDate);
          // 異常製品納品No.
          detailElement.odExReceSendNo = element.jrdReceNo;
          // 異常製品入荷/納品明細No.
          detailElement.odExReceSendDetailNo = element.jrdReceDetailNo;
          // 異常製品支払方式  1：不要
          detailElement.odExPayMethod = STR_ONE;
          // 備考
          detailElement.odRemarks = element.jrdRemarks;
          // 注文書出力 0：チェックしない
          detailElement.odOrderNoteOut = STR_ZERO;
          // 支払数
          detailElement.odPayQuantity = NUM_ZERO;
          detailElement.odUpdateUser = getUserInfo().UserId;

          this.saveOrderDetailForm[x] = detailElement;
        }
      }

      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      if (column.property === "odDueDate") {
        //編集可能の背景色
        return "bg-cell-editable";
      }
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
    },

    close() {
      this.$emit("cancel");
    },

    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 納期、注番の変更(見積単位⇒製品単位に変更)
    //納期コントロール
    dueDateInputProc(row, column) {
      //納期以外の場合、何もしない
      if (column.prop !== "odDueDate") {
        return;
      }
      return true;
    },
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
</style>
